import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthWrapper';
import AdminLayout from './AdminLayout';

const AdminRoute = () => {
  const { isAdmin } = useContext(AuthContext);

  // If not admin, redirect to homepage
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Otherwise, render the admin layout with child routes
  return <AdminLayout />;
};

export default AdminRoute;